export default __webpack_public_path__ + "static/media/celo.fbb0de16.png";